import { GeneralPropsType } from "@/common/types";
import { useAuth } from "@/contexts/Auth";
import ActivityLoading from "../ActivityLoading/ActivityLoading";
import HomeLoading from "../HomeLoading/HomeLoading";
import Loading from "../Loading";
import RewardLoading from "../RewardLoading/RewardLoading";
import SettingsLoading from "../SettingsLoading/SettingsLoading";
import BranchLoading from "../BranchLoading/BranchLoading";
import EmailBackupLoading from "../EmailBackupLoading";
import { useGlobalData } from "@/contexts/GlobalData";
import ManagementPackageLoading from "../ManagementPackageLoading";
import PortfolioLoading from "../PortfolioLoading";
import { memo } from "react";
import DotpLoading from "../DotpLoading";
export interface RequireLoginPropsType extends GeneralPropsType {
  showLoading?: boolean;
  keyPage?: string;
}
const loadingPages: Record<any, any> = {
  activity: <ActivityLoading />,
  reward: <RewardLoading />,
  settings: <SettingsLoading />,
  home: <HomeLoading />,
  branch: <BranchLoading />,
  "email-backup": <EmailBackupLoading />,
  dotp: <DotpLoading />,
  packages: <ManagementPackageLoading />,
  portfolio: <PortfolioLoading />
};
function RequireLogin({
  children,
  showLoading,
  keyPage
}: RequireLoginPropsType) {
  const {
    token,
    connectingBE,
    loginAppStep
  } = useAuth();
  const {
    languageData
  } = useGlobalData();
  if (!languageData || loginAppStep != "logged" || !token || connectingBE || keyPage == "home" && showLoading) {
    return <Loading className="relative z-[9999]" />;
  }
  if (showLoading && keyPage && keyPage != "home") {
    return loadingPages[keyPage] ?? <Loading className="relative z-[9999]" />;
  }
  return <>{children}</>;
}
export default memo(RequireLogin);